import React from 'react';
import { observer } from 'mobx-react';

import { store } from '../Store';

import { Hotspot } from './Hotspot';

const Hotspots = observer((props) => {
  return (
    <div className="hotspots">
      {store.hotspots.map((hotspot, i) => {
        return (
          <Hotspot 
            key={i}
            id={hotspot.id} 
            x={hotspot.x}
            y={hotspot.y}
            size={hotspot.size}
            visible={props.visible}
            visited={hotspot.visited}
            title={hotspot.id ? props.data[hotspot.id].title : ''}
            transitionDelay={i * 50}
          />
        )
      })}
    </div>
  )
});

export { Hotspots };